// extracted by mini-css-extract-plugin
module.exports = {"main-component":"mom_main-component__1m7h7"};